import * as React from 'react';
import './index.css';
export default function PlateCompany(props) {
    var contentData = props.contentData, _a = props.contentDataTitle, contentDataTitle = _a === void 0 ? {} : _a;
    return (React.createElement("div", { className: 'roll_buyer_seller_box' },
        React.createElement("div", { className: 'roll_machine_code_box' },
            React.createElement("div", { className: 'roll_machine_code_title' }, contentDataTitle.machineNum || '机打号码'),
            React.createElement("div", { className: 'roll_machine_code_val' }, contentData.machineNum),
            React.createElement("div", { className: 'roll_machine_num_title' }, contentDataTitle.machineNumber || '机器编号'),
            React.createElement("div", { className: 'roll_machine_num_val' }, contentData.machineNumber)),
        React.createElement("div", { className: 'roll_company_box' },
            React.createElement("div", { className: 'roll_company_title' }, contentDataTitle.sellerName || '销售方名称'),
            React.createElement("div", { className: 'roll_company_val' }, contentData.sellerName)),
        React.createElement("div", { className: 'roll_company_box' },
            React.createElement("div", { className: 'roll_company_title' }, contentDataTitle.sellerNs || '销方纳税人识别号'),
            React.createElement("div", { className: 'roll_company_val' }, contentData.sellerNs)),
        React.createElement("div", { className: 'roll_machine_code_box' },
            React.createElement("div", { className: 'roll_machine_code_title' }, contentDataTitle.invoiceDate || '开票日期'),
            React.createElement("div", { className: 'roll_machine_code_val' }, contentData.invoiceDate),
            React.createElement("div", { className: 'roll_machine_num_title' }, contentDataTitle.drawer || '开票员'),
            React.createElement("div", { className: 'roll_machine_num_val' }, contentData.drawer)),
        React.createElement("div", { className: 'roll_company_box' },
            React.createElement("div", { className: 'roll_company_title' }, contentDataTitle.buyerName || '购买方名称'),
            React.createElement("div", { className: 'roll_company_val' }, contentData.buyerName)),
        React.createElement("div", { className: 'roll_company_box' },
            React.createElement("div", { className: 'roll_company_title' }, contentDataTitle.buyerNs || '购方纳税人识别号'),
            React.createElement("div", { className: 'roll_company_val' }, contentData.buyerNs))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/RollTypeInvoicePlate/PlateCompany/index.js
// module id = 4201
// module chunks = 0